export default __webpack_public_path__ + "static/media/logo.36e0e9c9.jpeg";